// import useAuth from 'hooks/useAuth';

// import { Doc } from '../preferences/preferenceApi';

import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';

const apiHost = process.env.REACT_APP_API_URL;
const api_key = process.env.REACT_APP_OPENAI_KEY;
const project = 'document';

export async function fetchAnswerApi(question, apiKey, selectedDocs, history = [], conversationId) {
    // const { fetchBillings } = useAuth();

    let namePath = selectedDocs.name;
    if (selectedDocs.language === namePath) {
        namePath = '.project';
    }

    let docPath = 'default';
    if (selectedDocs.location === 'local') {
        docPath = 'local' + '/' + localStorage.getItem('user_token') + '/' + project + '/' + selectedDocs.name + '/';
    } else if (selectedDocs.location === 'remote') {
        docPath = selectedDocs.language + '/' + namePath + '/' + selectedDocs.version + '/' + selectedDocs.model + '/';
    }
    //in history array remove all keys except prompt and response
    history = history.map((item) => {
        return { prompt: item.prompt, response: item.response };
    });

    return fetch(apiHost + '/api/answer', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            question: question,
            api_key: api_key,
            embeddings_key: api_key,
            history: history,
            active_docs: docPath,
            conversation_id: conversationId,
            user: localStorage.getItem('user_token'),
            user_type: localStorage.getItem('user_type'),
            project: project
        })
    })
        .then((response) => {
            if (response.ok) {
                // console.log(response)
                return response.json();
                // if(response['sources'] === ""){
                //   return response.json();
                // } else {
                //   return Promise.reject(new Error("out_of_payment"));
                // }
            } else {
                return Promise.reject(new Error(response.statusText));
            }
        })
        .then((data) => {
            const result = data.answer;
            // fetchBillings();
            return {
                answer: result,
                query: question,
                result,
                sources: data.sources,
                conversationId: data.conversation_id,
                user: localStorage.getItem('user_token')
            };
        });
}

export function fetchAnswerSteaming(question, model, apiKey, selectedDocs, history = [], conversationId, onEvent) {
    let namePath = selectedDocs.name;

    if (selectedDocs.language === namePath) {
        namePath = '.project';
    }

    let docPath = 'default';
    if (selectedDocs.location === 'local') {
        docPath = 'local' + '/' + localStorage.getItem('user_token') + '/' + project + '/' + selectedDocs.name + '/';
    } else if (selectedDocs.location === 'remote') {
        docPath = selectedDocs.language + '/' + namePath + '/' + selectedDocs.version + '/' + selectedDocs.model + '/';
    }

    // console.log(docPath)

    history = history.map((item) => {
        return { prompt: item.prompt, response: item.response };
    });

    if (model === 'gpt-4-1106') {
        return new Promise((resolve, reject) => {
            const body = {
                question: question,
                api_key: api_key,
                embeddings_key: api_key,
                history: JSON.stringify(history),
                active_docs: docPath,
                conversation_id: conversationId,
                user: localStorage.getItem('user_token'),
                user_type: localStorage.getItem('user_type'),
                project: project
            };

            // console.log(body)

            fetch(`${apiHost}/stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => {
                    if (!response.body) throw Error('No response body');

                    const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let counterrr = 0;
                    const processStream = ({ done, value }) => {
                        if (done) {
                            // console.log(counterrr);
                            return;
                        }

                        counterrr += 1;

                        const chunk = decoder.decode(value);

                        const lines = chunk.split('\n');

                        for (let line of lines) {
                            if (line.trim() == '') {
                                continue;
                            }
                            if (line.startsWith('data:')) {
                                line = line.substring(5);
                            }

                            const messageEvent = new MessageEvent('message', {
                                data: line
                            });

                            onEvent(messageEvent); // handle each message
                        }

                        reader.read().then(processStream).catch(reject);
                    };

                    reader.read().then(processStream).catch(reject);
                })
                .catch((error) => {
                    console.error('Connection failed:', error);
                    reject(error);
                });
        });
    } else {
        return new Promise((resolve, reject) => {
            const body = {
                question: question,
                model: model,
                api_key: api_key,
                embeddings_key: api_key,
                history: JSON.stringify(history),
                active_docs: docPath,
                conversation_id: conversationId,
                user: localStorage.getItem('user_token'),
                user_type: localStorage.getItem('user_type'),
                project: project
            };

            // console.log(body)

            fetch(`${apiHost}/stream/free`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => {
                    if (!response.body) throw Error('No response body');

                    const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let counterrr = 0;
                    const processStream = ({ done, value }) => {
                        if (done) {
                            // console.log(counterrr);
                            return;
                        }

                        counterrr += 1;

                        const chunk = decoder.decode(value);

                        const lines = chunk.split('\n');

                        for (let line of lines) {
                            if (line.trim() == '') {
                                continue;
                            }
                            if (line.startsWith('data:')) {
                                line = line.substring(5);
                            }

                            const messageEvent = new MessageEvent('message', {
                                data: line
                            });

                            onEvent(messageEvent); // handle each message
                        }

                        reader.read().then(processStream).catch(reject);
                    };

                    reader.read().then(processStream).catch(reject);
                })
                .catch((error) => {
                    console.error('Connection failed:', error);
                    reject(error);
                });
        });
    }
}

export async function sendFeedback(prompt, response, feedback) {
    const res = await store.dispatch(
        apiSlice.endpoints.postChatFeedback.initiate({
            question: prompt,
            answer: response,
            feedback,
            user: localStorage.getItem('user_token')
        })
    );
    if (res?.data !== undefined || res?.isSuccess) return Promise.resolve();
    return Promise.reject();
}
